module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-ties.6903750d.png";